// extracted by mini-css-extract-plugin
export default {"button":"button_button__AfAPt","contained":"button_contained__ywV6S","label":"button_label__HvW76"};